import { render, staticRenderFns } from "./VaFileUploadSingleItem.vue?vue&type=template&id=0129f960&"
import script from "./VaFileUploadSingleItem.vue?vue&type=script&lang=js&"
export * from "./VaFileUploadSingleItem.vue?vue&type=script&lang=js&"
import style0 from "./VaFileUploadSingleItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports